import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { authClient } from '@/lib/auth'
import { useTopNav } from '@/context/top-nav-provider'
import { Main } from '@/components/layout/main'
import { GoalAchievementReport } from '@/features/reports/goal-achievement'

function GoalAchievementReportPage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()
  const { setLinks, setFixed } = useTopNav()

  useEffect(() => {
    setLinks([
      { title: 'Overview', href: '/' },
      { title: 'Reports', href: '/reports' },
      {
        title: 'Goal Achievement',
        href: '/reports/goal-achievement',
        isActive: true,
      },
    ])
    setFixed(true)
    return () => {
      setLinks([])
    }
  }, [setLinks, setFixed])

  if (isPending || !activeOrganization) return null

  return (
    <Main className='flex flex-1 flex-col gap-6'>
      <GoalAchievementReport organizationId={activeOrganization.id} />
    </Main>
  )
}

export const Route = createFileRoute(
  '/_authenticated/_organization/reports/goal-achievement'
)({
  beforeLoad: async () => requireRoles(['support_coordinator', 'admin']),
  component: GoalAchievementReportPage,
})
